import template from './swag-cms-extensions-form-editor-settings-field-type-footer.html.twig';

export default {
    template,
    computed: {
        field() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem;
        },

        required: {
            set(newRequired) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldProperty(
                    this.field.id,
                    'required',
                    newRequired,
                );
            },
            get() {
                return this.field.required;
            },
        },

        errorMessage: {
            set(newErrorMessage) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldProperty(
                    this.field.id,
                    'errorMessage',
                    newErrorMessage,
                );
            },
            get() {
                return this.field.errorMessage;
            },
        },
    },
}
